import { Skeleton } from "@/components/ui/skeleton";

export function TableLoading() {
	return (
		<div className="w-full space-y-4">
			{/* Table Header */}

			{/* Table Rows */}
			{[1, 2, 3, 4, 5].map((row) => (
				<div
					key={row}
					className="flex items-center justify-between py-4 border-b"
				>
					<div className="flex items-center gap-4">
						<Skeleton className="w-4 h-4 rounded-full" />
						<Skeleton className="h-4 w-[120px]" />
					</div>
					<div className="flex items-center gap-4">
						<Skeleton className="h-4 w-[100px]" />
						<Skeleton className="h-4 w-[140px]" />
						<Skeleton className="h-4 w-[160px]" />
						<Skeleton className="h-8 w-[100px] rounded-md" />
					</div>
				</div>
			))}
		</div>
	);
}
